<script lang="ts" setup>
    import '../../../css/choice.css';
    import '../../../css/patientFlag.css';
    import { onMounted, ref, reactive, computed } from 'vue';
    import { ICol, RenderModeType } from "../../lib/ChoiceTableHelpers";
    import { IPatientFlagPatientAssignItem, IPatientFlagBasicSettingsBase, IPatientFlagSetupFlagItem } from '../../lib/Models/Setup/PatientFlagSetupModel';
    import ChoiceTable from "../../components/ChoiceTable.vue";
    import ResizeMonitor from '../../components/ResizeMonitor.vue'
    import PatientFlagBadge from '../../components/Choice/Patient/PatientFlagBadge.vue';
    import MessageBadge from '../../components/Messages/MessageBadge.vue';

    const windowHeight = ref<number>();

    const props = defineProps<{
        patientFlagList?: IPatientFlagPatientAssignItem[]
    }>();

    defineExpose({getSelected,setSelected});
    const emit = defineEmits<{
        (e: "pageLoaded"): void
    }>();


    const formData = reactive<{
        tableData: IPatientFlagPatientAssignItem[],
        selectedRow: IPatientFlagSetupFlagItem[],
    }>({
        tableData: [],
        selectedRow: []
    });

    onMounted(async () => {
        formData.tableData = props.patientFlagList ?? [];
        emit("pageLoaded");
        windowResize();
    });

    const tableColumns = computed<ICol[]>(() => {
            const columns: ICol[] = [];
            columns.push(
                { Name: '', DataField:"patientAssigned", RenderMode: RenderModeType.Selection },
                { Name: 'Flag', DataField: 'empty' },
                { Name: 'Description', DataField: 'longDescription', ExtraData: "LongDescription" },
                { Name: 'Displays in Portal(s)', ExtraData: "Portals" },
                { Name: 'Active', DataField: 'active', RenderMode: RenderModeType.BoolYesNo, ExtraData: "Active" });
            return columns;
        });

    function windowResize() {
        windowHeight.value = window.innerHeight - 30;
    }

    function activePortals(row: any): string[]
    {
        const portals = [];
        if (row.emrPortalActive)
            portals.push("EMR");
        if (row.billingPortalActive)
            portals.push("Billing");
        if (row.schedulerPortalActive)
            portals.push("Scheduler");
        if (row.documentPortalActive)
            portals.push("Document");
        return portals;
    }

    function onSelectChanged(checked: boolean|undefined, colData: ICol, row?: Record<string, any>) {
        const rowData = <IPatientFlagPatientAssignItem> row;
        if (checked) {
            formData.selectedRow?.push({flagSetupId: rowData.flagSetupId, description: rowData.longDescription});
        } else {
            if (!formData.selectedRow)
                return;
            const index = formData.selectedRow.findIndex(item => item.flagSetupId == rowData.flagSetupId);
            if (index > -1)
                formData.selectedRow.splice(index, 1);
        }
    } 

    function getSelected() {
        return formData.selectedRow;
    }

    function setSelected(delimetedFlagSetupId: string) {
        formData.selectedRow = [];
        const list = delimetedFlagSetupId.split("{}");
        for (let listItem of list) {
            const index = formData.tableData.findIndex( item => item.flagSetupId == +listItem);
            if (index >= 0) {
                formData.tableData[index].patientAssigned = true;
                formData.selectedRow?.push({flagSetupId: formData.tableData[index].flagSetupId, description: formData.tableData[index].longDescription});
            }
        }
    }

</script>

<style scoped>
    .background {
        background-color: #dbebff;
    }
</style>

<template>
    <ResizeMonitor @resize="windowResize" />

    <div class="row mt-2">
        <div class="col">
            <ChoiceTable 
                ref="SetupTable"
                :columns="tableColumns" 
                :data="formData.tableData" 
                :show-filters="false" 
                :allowSorting="false"
                :height="windowHeight"
                fontSize="smaller"
                @selectChanged="onSelectChanged">
                <template #cell="{col, row, value}">
                    <template v-if="'Flag' === col.Name">
                        <PatientFlagBadge :flag="<IPatientFlagBasicSettingsBase>row" />
                    </template>
                    <template v-if="'LongDescription' === col.ExtraData">
                        {{ value }}
                        <MessageBadge v-if="!row['active']">
                            Inactive
                        </MessageBadge>
                    </template>
                    <template v-if="'Portals' === col.ExtraData">
                        {{ activePortals(row).join(", ") }}
                    </template>                        
                </template>
            </ChoiceTable>
        </div>
    </div>
</template>

